"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UnauthorizedError extends client_library_1.ExtendableError {
    constructor() {
        super(`Unauthorized access: not enough permissions`);
    }
}
exports.default = UnauthorizedError;
//# sourceMappingURL=UnauthorizedError.js.map